<template>
  <tr
    style="cursor: pointer;"
    :class="{ 'pink lighten-5': line.duplicate || isDuplicate, 
      'blue lighten-5': updated && (!line.duplicate && !isDuplicate), 
      'green lighten-5': created && (!line.duplicate && !isDuplicate), 
      'grey lighten-4': closed && (!line.duplicate && !isDuplicate)}"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="!batch.commited ? toggleEditDialog() : null"
  >
    <td v-for="(header,i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <span v-if="header.type == 'time'">{{ getUTCTime(getObjectPath(header.value, line)) || "-" }}</span>
      <span
        v-if="header.type == 'text'"
      >{{ getObjectPathRootExists(header.value, line) ? getObjectPath(header.value, line) : '-' || "-" }}</span>

      <span v-if="header.type === 'array'">
        <span v-if="getObjectPathRootExists(header.value, line)">
          <div
            v-for="duplicate in JSON.parse(getObjectPath(header.value, line))"
            :key="duplicate.id"
          >{{`Batch: ${duplicate.batchId} Line: ${duplicate.lineId} (${duplicate.type})`}}</div>
        </span>
      </span>

      <!--ACTIONS COLUMN -->
      <div
        v-if="header.type == 'action' && userAuthClass"
        class="justify-center layout px-0"
        @click.stop
      >
        <!-- TRIP OPTIONS MENU -->
        <v-menu bottom left :disabled="closed">
          <v-btn icon flat color="grey" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <basic-list-tile title="Edit" icon="edit" :onClick="toggleEditDialog"></basic-list-tile>
            <basic-list-tile
              title="Delete Line"
              v-if="!closed"
              icon="delete"
              color="red lighten-3"
              :onClick="toggleDeleteDialog"
            ></basic-list-tile>
          </v-list>
        </v-menu>
      </div>
      <!--END ACTIONS COLUMN -->
    </td>
    <!-- END CELLS -->

    <!--  DIALOGS  -->
    <!-- Line edit dialog -->
    <v-dialog lazy v-model="editDialog" max-width="700px" @keydown.esc="editDialog = false">
      <edit-line
        @close="editDialog = false"
        :line="line"
        :batch="batch"
        :hasDuplicateDriver="!!duplicateDriver"
        :hasDuplicateVehicle="!!duplicateVehicle"
      ></edit-line>
    </v-dialog>
    <!-- Line Delete dialog -->
    <v-dialog lazy v-model="deleteDialog" max-width="400px" @keydown.esc="deleteDialog = false">
      <delete-line @close="deleteDialog = false" :line="line"></delete-line>
    </v-dialog>
  </tr>
</template>

<script>
import EditLine from './lineEdit'
import DeleteLine from './lineDelete'
import FormatDates from '@/services/mixins/formatDates'
import Store from '@/store/computed/storeHelpers'
import AllocationService from '@/services/requests/allocationService'

import CreatedUpdatedRows from '@/services/mixins/createdUpdatedRows'
import RowDisplayMethods from '@/services/mixins/rowDisplayMethods'
export default {
  mixins: [FormatDates, CreatedUpdatedRows, RowDisplayMethods],
  components: {
    EditLine,
    DeleteLine,
  },
  props: {
    batch: Object,
    line: Object,
    headers: Array,
  },
  data() {
    return {
      prefix: 'line',
      editDialog: false,
      deleteDialog: false,
      actionsMenu: false,
    }
  },
  computed: {
    batchLinesByDate: Store.getSet({
      store: 'batchAllocations',
      prop: 'batchLinesByDate',
    }),
    closed() {
      return !!this.line.allocationId
    },
    duplicateDriver() {
      const duplicate = this.batchLinesByDate.find(
        (line) =>
          this.line.driverId === line.driverId &&
          !line.duplicate &&
          this.line.id !== line.id
      )
      return duplicate
    },
    duplicateVehicle() {
      const duplicate = this.batchLinesByDate.find(
        (line) =>
          this.line.vehicleId === line.vehicleId &&
          !line.duplicate &&
          this.line.id !== line.id
      )
      return duplicate
    },
    isDuplicate() {
      return !!this.duplicateDriver || !!this.duplicateVehicle
    },
  },
  methods: {
    toggleEditDialog() {
      if (
        !this.closed &&
        !this.batch.commited &&
        this.$store.state.user.userAuthClass.allocationStagingWrite
      ) {
        this.editDialog = !this.editDialog
      }
    },
    toggleDeleteDialog() {
      this.deleteDialog = !this.deleteDialog
    },
  },
}
</script>